import { LazyImage } from '@components/common/image'

type ProjectCardProps = {
  title: string
  description: string
  imageName: string
  imagePath: string
  alt: string
}

const ProjectCard = ({
  title,
  description,
  imageName,
  imagePath,
  alt,
}: ProjectCardProps) => {
  return (
    <div className="flex flex-col my-3 bg-white mx-auto md:m-5 shadow-lg max-w-sm lg:max-w-xs rounded-t-lg">
      <LazyImage
        name={imageName}
        path={imagePath}
        alt={alt}
        className="rounded-t-lg mb-2"
      />
      <div className="px-5">
        <h1 className="text-2xl font-600 my-3 leading-tight">{title}</h1>
        <h4 className="mb-5 leading-tight">{description}</h4>
      </div>
    </div>
  )
}

export default ProjectCard
